import React, { useState, useEffect, useCallback } from 'react';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F',GREEN='#22C55E',RED='#EF4444',PURPLE='#7C3AED';
const s = {
  btn:{padding:'9px 20px',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer',border:'none',fontFamily:"'Syne',sans-serif"},
  input:{background:'#F4F4F4',border:'0.5px solid #D3D1C7',borderRadius:'9px',padding:'9px 13px',fontSize:'13px',width:'100%',fontFamily:"'Syne',sans-serif",outline:'none',boxSizing:'border-box'},
  label:{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'4px',display:'block'},
  section:{background:'#F8F8F8',borderRadius:'12px',padding:'16px',marginBottom:'14px'},
  sectionTitle:{fontWeight:800,fontSize:'14px',marginBottom:'12px',display:'flex',alignItems:'center',gap:'8px'},
};

const ACTE = [
  {key:'contract_vanzare', label:'Contract Vanzare-Cumparare', icon:'📝', color:NAVY, desc:'Contract oficial ITL 054'},
  // ASCUNSE TEMPORAR - se activeaza ulterior
  // {key:'cerere_radiere', label:'Cerere Radiere DRPCIV', icon:'🏛️', color:'#D97706', desc:'Certificat radiere'},
  // {key:'cerere_inmatriculare', label:'Cerere Inmatriculare DRPCIV', icon:'🚗', color:GREEN, desc:'Transcriere/inmatriculare'},
  // {key:'scoatere_evidenta_pf', label:'Scoatere Evidenta Primarie PF', icon:'🏠', color:PURPLE, desc:'Persoana fizica'},
  // {key:'scoatere_evidenta_pj', label:'Scoatere Evidenta Primarie PJ', icon:'🏢', color:PURPLE, desc:'Persoana juridica'},
  // {key:'declaratie_fiscala_pf', label:'Declaratie Fiscala PF', icon:'📋', color:'#059669', desc:'Impozit transport PF'},
  // {key:'declaratie_fiscala_pj', label:'Declaratie Fiscala PJ', icon:'📋', color:'#059669', desc:'Impozit transport PJ'},
  // {key:'delegatie_vanzator', label:'Delegatie Vanzator', icon:'✍️', color:'#0891B2', desc:'Delegatie angajati'},
  // {key:'leasing_pj', label:'Cerere Finalizare Leasing PJ', icon:'🏦', color:'#7C3AED', desc:'Finalizare leasing PJ'},
];

const numberToWords = (num) => {
  if (!num || isNaN(num)) return '';
  const n = parseInt(num);
  const ones = ['','unu','doi','trei','patru','cinci','sase','sapte','opt','noua','zece','unsprezece','doisprezece','treisprezece','paisprezece','cincisprezece','saisprezece','saptesprezece','optsprezece','nouasprezece'];
  const tens = ['','','douazeci','treizeci','patruzeci','cincizeci','saizeci','saptezeci','optzeci','nouazeci'];
  if (n === 0) return 'zero';
  if (n < 20) return ones[n];
  if (n < 100) return tens[Math.floor(n/10)] + (n%10 ? 'si' + ones[n%10] : '');
  if (n < 1000) return (n===100?'una':'') + (Math.floor(n/100)>1?ones[Math.floor(n/100)]:'') + 'sute' + (n%100?' '+numberToWords(n%100):'');
  if (n < 1000000) return numberToWords(Math.floor(n/1000)) + 'mii' + (n%1000?' '+numberToWords(n%1000):'');
  return String(n);
};

const api = async (endpoint, options={}) => {
  const token = localStorage.getItem('token');
  const res = await fetch('/api' + endpoint, {
    headers:{'Content-Type':'application/json',...(token?{Authorization:'Bearer '+token}:{})},
    ...options
  });
  return res.json();
};

const DocUploadMini = ({ vehicleId, docType, label, icon, onOcrComplete }) => {
  const [uploaded, setUploaded] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [extracting, setExtracting] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    api(`/documents/vehicle/${vehicleId}`).then(d => {
      if (d.documents) setUploaded(d.documents.find(x => x.doc_type === docType) || null);
    });
  }, [vehicleId, docType]);

  const upload = async (file) => {
    setUploading(true);
    const fd = new FormData();
    fd.append('file', file);
    fd.append('vehicle_id', vehicleId);
    fd.append('doc_type', docType);
    const token = localStorage.getItem('token');
    const res = await fetch('/api/documents/upload', { method:'POST', headers:{Authorization:'Bearer '+token}, body:fd });
    const data = await res.json();
    if (data.document) {
      setUploaded(data.document);
      if (onOcrComplete) {
        setExtracting(true);
        setMsg('🤖 Se extrag datele...');
        const ocrData = await api('/ocr/extract', {
          method:'POST',
          body: JSON.stringify({ document_id: data.document.id, vehicle_id: vehicleId })
        });
        if (ocrData.success) { onOcrComplete(ocrData.data); setMsg('✓ Date completate automat!'); }
        else setMsg('⚠ Completati manual');
        setExtracting(false);
        setTimeout(() => setMsg(''), 4000);
      }
    }
    setUploading(false);
  };

  const del = async () => {
    if (!window.confirm('Stergi?')) return;
    const token = localStorage.getItem('token');
    await fetch(`/api/documents/${uploaded.id}`, { method:'DELETE', headers:{Authorization:'Bearer '+token} });
    setUploaded(null);
    if (onOcrComplete) onOcrComplete(null);
  };

  return (
    <div style={{marginBottom:'6px'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',background:'#fff',border:`0.5px solid ${uploaded?'#86EFAC':'#D3D1C7'}`,borderRadius:'9px',padding:'10px 14px'}}>
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          <div style={{width:'32px',height:'32px',borderRadius:'7px',background:uploaded?'#DCFCE7':'#F4F4F4',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px'}}>{icon}</div>
          <div>
            <div style={{fontWeight:600,fontSize:'12px'}}>{label}</div>
            <div style={{fontSize:'10px',color:uploaded?'#15803D':'#888',marginTop:'1px'}}>
              {extracting ? '🤖 Se proceseaza OCR...' : uploaded ? `✓ ${uploaded.original_filename}` : 'Neîncarcat'}
            </div>
          </div>
        </div>
        <div style={{display:'flex',gap:'5px'}}>
          {uploaded ? (
            <>
              <a href={uploaded.s3_key} target="_blank" rel="noreferrer" style={{...s.btn,background:'#E8EEF5',color:NAVY,padding:'4px 10px',fontSize:'10px',textDecoration:'none'}}>👁</a>
              <button onClick={del} style={{...s.btn,background:'#FEE2E2',color:RED,padding:'4px 10px',fontSize:'10px'}}>🗑</button>
            </>
          ) : (
            <label style={{...s.btn,background:GOLD,color:DARK,padding:'4px 12px',fontSize:'10px',cursor:'pointer'}}>
              {uploading||extracting ? '⏳' : '+ Incarca'}
              <input type="file" style={{display:'none'}} accept=".jpg,.jpeg,.png,.pdf,.heic"
                onChange={e=>{ if(e.target.files[0]) upload(e.target.files[0]); e.target.value=''; }}
                disabled={uploading||extracting}/>
            </label>
          )}
        </div>
      </div>
      {msg && <div style={{fontSize:'11px',color:msg.includes('✓')?'#15803D':msg.includes('🤖')?PURPLE:'#D97706',padding:'4px 8px'}}>{msg}</div>}
    </div>
  );
};

export default function ActeAuto({ vehicle }) {
  const [buyerType, setBuyerType] = useState('person');
  const [salePrice, setSalePrice] = useState('');
  const [saleCurrency, setSaleCurrency] = useState('RON');
  const [contractPlace, setContractPlace] = useState('Iasi');
  const [keepPlates, setKeepPlates] = useState(true);
  const [buyerOcr, setBuyerOcr] = useState(null);
  const [msg, setMsg] = useState('');
  const [generating, setGenerating] = useState(null);

  useEffect(() => {
    api(`/acte/buyer/${vehicle.id}`).then(d => {
      if (d.buyer) {
        setSalePrice(d.buyer.sale_price || '');
        setSaleCurrency(d.buyer.sale_currency || 'RON');
        setContractPlace(d.buyer.contract_place || 'Iasi');
        setKeepPlates(d.buyer.keep_plates !== false);
        setBuyerType(d.buyer.buyer_type || 'person');
      }
    });
  }, [vehicle.id]);

  const handleOcrCumparator = useCallback((ocrData) => {
    setBuyerOcr(ocrData);
  }, []);

  const savePrice = async () => {
    await api(`/acte/buyer/${vehicle.id}`, {
      method:'POST',
      body: JSON.stringify({
        buyer_type: buyerType,
        sale_price: salePrice,
        sale_currency: saleCurrency,
        contract_place: contractPlace,
        keep_plates: keepPlates,
      })
    });
    setMsg('✓ Date salvate!');
    setTimeout(()=>setMsg(''), 2000);
  };

  const generatePDF = async (docType) => {
    setGenerating(docType);
    setMsg(`⏳ Se genereaza ${ACTE.find(a=>a.key===docType)?.label}...`);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`/api/docs/generate/${vehicle.id}`, {
        method:'POST',
        headers:{'Content-Type':'application/json', Authorization:'Bearer '+token},
        body: JSON.stringify({
          doc_type: docType,
          extra: {
            sale_price: salePrice,
            sale_currency: saleCurrency,
            contract_place: contractPlace,
            keep_plates: keepPlates,
            contract_date: new Date().toLocaleDateString('ro-RO'),
            registration_type: 'transcriere',
            deregistration_type: 'cerere',
          }
        })
      });
      if (!res.ok) { const err = await res.json(); setMsg('✗ '+err.error); setGenerating(null); return; }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${docType}_${vehicle.plate_number||'document'}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
      setMsg('✓ Document generat si descarcat!');
    } catch(e) { setMsg('✗ Eroare: '+e.message); }
    setGenerating(null);
    setTimeout(()=>setMsg(''), 5000);
  };

  const SectionNum = ({n}) => (
    <span style={{background:GOLD,color:DARK,borderRadius:'50%',width:'22px',height:'22px',display:'inline-flex',alignItems:'center',justifyContent:'center',fontSize:'11px',fontWeight:900,flexShrink:0}}>{n}</span>
  );

  const priceInWords = salePrice ? numberToWords(salePrice) + ' ' + saleCurrency : '';

  return (
    <div>
      {msg && (
        <div style={{background:msg.includes('✓')?'#DCFCE7':msg.includes('⏳')?'#EDE9FE':'#FEE2E2',borderRadius:'8px',padding:'10px',fontSize:'12px',color:msg.includes('✓')?'#15803D':msg.includes('⏳')?PURPLE:'#B91C1C',marginBottom:'14px',position:'sticky',top:'70px',zIndex:100}}>
          {msg}
        </div>
      )}

      {/* 1 — Upload documente */}
      <div style={s.section}>
        <div style={s.sectionTitle}><SectionNum n="1"/> 📎 Documente Cumparator</div>
        <div style={{display:'flex',gap:'8px',marginBottom:'10px'}}>
          <button onClick={()=>setBuyerType('person')} style={{...s.btn,flex:1,background:buyerType==='person'?NAVY:'#F4F4F4',color:buyerType==='person'?'#fff':'#555',border:'0.5px solid #D3D1C7',fontSize:'12px'}}>
            👤 Persoana Fizica
          </button>
          <button onClick={()=>setBuyerType('company')} style={{...s.btn,flex:1,background:buyerType==='company'?NAVY:'#F4F4F4',color:buyerType==='company'?'#fff':'#555',border:'0.5px solid #D3D1C7',fontSize:'12px'}}>
            🏢 Firma (PJ)
          </button>
        </div>
        <DocUploadMini vehicleId={vehicle.id} docType="ci_cumparator" label="CI Cumparator — OCR automat" icon="🪪" onOcrComplete={handleOcrCumparator}/>
        {buyerType==='company' && <>
          <DocUploadMini vehicleId={vehicle.id} docType="ci_administrator" label="CI Administrator Firma" icon="🪪"/>
          <DocUploadMini vehicleId={vehicle.id} docType="statut_societate" label="Statut Societate (optional)" icon="📘"/>
        </>}
        {buyerOcr && (
          <div style={{background:'#F0FDF4',border:'1px solid #86EFAC',borderRadius:'8px',padding:'10px',marginTop:'8px'}}>
            <div style={{fontSize:'11px',fontWeight:700,color:GREEN,marginBottom:'6px'}}>✓ Date cumparator extrase prin OCR:</div>
            <div style={{display:'flex',flexWrap:'wrap',gap:'5px'}}>
              {Object.entries(buyerOcr).filter(([k,v])=>v&&v!=='null'&&v!=='').map(([k,v])=>(
                <div key={k} style={{background:'#fff',border:'0.5px solid #86EFAC',borderRadius:'5px',padding:'2px 7px',fontSize:'10px'}}>
                  <span style={{color:'#888'}}>{k}: </span><strong>{String(v)}</strong>
                </div>
              ))}
            </div>
          </div>
        )}
        <div style={{fontSize:'11px',color:'#888',marginTop:'6px'}}>
          💡 Incarca buletinul cumparatorului — datele se completeaza automat in toate documentele generate
        </div>
      </div>

      {/* 2 — Pret vanzare */}
      <div style={s.section}>
        <div style={s.sectionTitle}><SectionNum n="2"/> 💰 Pret Vanzare Auto</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 90px',gap:'10px',marginBottom:'10px'}}>
          <div>
            <label style={s.label}>Pret numeric</label>
            <input style={s.input} type="number" placeholder="15000" value={salePrice}
              onChange={e=>setSalePrice(e.target.value)}/>
          </div>
          <div>
            <label style={s.label}>Valuta</label>
            <select style={s.input} value={saleCurrency} onChange={e=>setSaleCurrency(e.target.value)}>
              <option>RON</option><option>EUR</option><option>USD</option>
            </select>
          </div>
        </div>
        {priceInWords && (
          <div style={{background:'#FEF3DC',border:'1px solid '+GOLD,borderRadius:'8px',padding:'10px',marginBottom:'10px'}}>
            <div style={{fontSize:'10px',color:'#888',fontWeight:700,textTransform:'uppercase',marginBottom:'3px'}}>Pret in litere (pentru contract):</div>
            <div style={{fontSize:'13px',fontWeight:700,color:DARK}}>{priceInWords}</div>
          </div>
        )}
        <button onClick={savePrice} style={{...s.btn,background:GOLD,color:DARK,width:'100%',fontSize:'12px'}}>
          💾 Salveaza pretul
        </button>
      </div>

      {/* 3 — Informatii extra */}
      <div style={s.section}>
        <div style={s.sectionTitle}><SectionNum n="3"/> ⚙️ Informatii Extra</div>
        <div style={{marginBottom:'12px'}}>
          <label style={s.label}>📍 Locul semnarii contractului</label>
          <input style={s.input} value={contractPlace} onChange={e=>setContractPlace(e.target.value)} placeholder="Iasi"/>
        </div>
        <div>
          <label style={s.label}>Pastrare numar inmatriculare</label>
          <div style={{display:'flex',gap:'8px',marginTop:'4px'}}>
            <button onClick={()=>setKeepPlates(true)} style={{...s.btn,flex:1,background:keepPlates?GREEN:'#F4F4F4',color:keepPlates?'#fff':'#555',border:'0.5px solid #D3D1C7',fontSize:'12px'}}>
              DA — Pastrez numarul
            </button>
            <button onClick={()=>setKeepPlates(false)} style={{...s.btn,flex:1,background:keepPlates===false?RED:'#F4F4F4',color:keepPlates===false?'#fff':'#555',border:'0.5px solid #D3D1C7',fontSize:'12px'}}>
              NU — Predau placutele
            </button>
          </div>
        </div>
      </div>

      {/* 4 — Generare documente */}
      <div style={s.section}>
        <div style={s.sectionTitle}><SectionNum n="4"/> 📝 Genereaza Documente Auto</div>
        <div style={{background:'#F4F4F4',borderRadius:'8px',padding:'10px',marginBottom:'14px',display:'flex',gap:'8px',flexWrap:'wrap'}}>
          {[['Nr.', vehicle.plate_number],['Marca', vehicle.brand],['Model', vehicle.model],['An', vehicle.year],['VIN', vehicle.vin],['Pret', salePrice?salePrice+' '+saleCurrency:'—']].map(([label,val])=>(
            <div key={label} style={{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'6px',padding:'4px 8px',fontSize:'11px'}}>
              <span style={{color:'#888'}}>{label}: </span><strong>{val||'—'}</strong>
            </div>
          ))}
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'10px'}}>
          {ACTE.map(act => (
            <div key={act.key} style={{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'12px',padding:'14px',borderTop:`3px solid ${act.color}`}}>
              <div style={{fontSize:'20px',marginBottom:'6px'}}>{act.icon}</div>
              <div style={{fontWeight:700,fontSize:'12px',marginBottom:'2px'}}>{act.label}</div>
              <div style={{fontSize:'10px',color:'#888',marginBottom:'10px'}}>{act.desc}</div>
              <button onClick={()=>generatePDF(act.key)} disabled={!!generating}
                style={{...s.btn,background:generating===act.key?'#E5E5E5':act.color,color:'#fff',fontSize:'11px',padding:'7px 12px',width:'100%'}}>
                {generating===act.key ? '⏳ Se genereaza...' : '⬇ Descarca PDF'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
